let _permissions = [];

export function getPermissions() {
  return _permissions;
}

export function setPermissions(permissions) {
  _permissions = permissions;
}
